var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Not Found 404")])])])}]

export { render, staticRenderFns }